import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import './FlightDetailsModal.css';
import SelectBoxPointsPlusMoney from '../../common/selectBoxPointsPlusMoney/SelectBoxPointsPlusMoney.jsx';
import ExchangeService from '../../../services/exchange/ExchangeService.js';
import I18n from 'i18n-react';
import format from '../../../utils/FormatValue.js';
import InfoModal from '../../searchBox/infoModal/InfoModal.jsx';
import _ from 'lodash';

const ADULT = 'ADULT';
const propTypes = {
  id: PropTypes.string.isRequired,
  onSelectRecomendation: PropTypes.func,
  prices: PropTypes.object,
  cabinCategory: PropTypes.string,
  flight: PropTypes.object,
  callbackFinalizeGetPoints: PropTypes.func.isRequired,
  callbackSelectPointsPlusMoney: PropTypes.func.isRequired
};

const defaultProps = {
  prices: null,
  cabinCategory: null,
  flight: null
};

class PointsPlusMoneyDetailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      onlyPointsIsChecked: true,
      finalizeGetPointsPlusMoney: false
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    this.getPointsPlusMoney().then(response => {
      if (response.error) {
        this.showModal(I18n.translate('modalSelect.error').toString());
      } else {
        const isPointsPlusMoney = response.ranges ? true : false;
        this.setState({
          rangesPointsPlusMoneyResponse: response,
          finalizeGetPointsPlusMoney: true,
          renderPointsPlusMoney: isPointsPlusMoney,
          optionAndValuesSelect: isPointsPlusMoney ? this.getValuesAndOptions(response) : null,
          selectPointsPlusMoney: isPointsPlusMoney ? this.getRangeDefault(response) : null,
          valuePoints: response.points ? response.points.value : null
        });
      }
      this.props.callbackFinalizeGetPoints(true);
    });
  }

  changeValue = value => {
    const response = this.state.rangesPointsPlusMoneyResponse;
    const filter = response.ranges.filter(range => range.id === Number(value))[0];    
    this.setState({
      selectPointsPlusMoney: filter
    });
    this.props.callbackSelectPointsPlusMoney(filter);
  };

  getValuesAndOptions(response) {
    let options = [];
    let values = [];
    response.ranges.map(range => {
      options.push(
        I18n.translate('modalSelect.value.pointsPlusMoney', {
          points: format.formatPoints(range.points),
          money: format.formatAmount(range.amount)
        })
      );
      values.push(range.id);
    });
    return { values: values, options: options };
  }

  getRangeDefault(response) {
    const rangeDefault = response.ranges.filter(range => range.isDefault)[0];
    return rangeDefault || null;
  }

  getPointsPlusMoney() {
    const priceAdult = _.filter(this.props.prices, price => price.category === this.props.cabinCategory && price.passenger === ADULT)[0];
    const { originAirport, finalDestination, operatingCarriers, departureDate, departureTime } = this.props.flight;

    const flight = {
      departureFlightAirport: originAirport,
      arrivalFlightAirport: finalDestination,
      cabin: this.props.cabinCategory,
      operatingCarriers: operatingCarriers,
      classType: priceAdult.classType,
      departureFlightDate: departureDate,
      departureFlightTime: departureTime,
      value: priceAdult.value,
      currency: priceAdult.currency,
      passengerType: priceAdult.passenger
    };

    if (flight.classType === 'AWARD') {
      let partner = this.assemblerPartnerWhenAward(this.props.flight);
      partner !== null ? flight.operatingCarriers = partner : null;
    }

    return ExchangeService.getPointsPlusMoney(flight);
  }


  assemblerPartnerWhenAward(flight) {
    let partner = [];
    
    if (flight.recommendations === null) {
      let fare = flight.fare;
      let fareBasis = this.getFareBasisFromFare(fare);
      
      partner.push(this.extractPartner(fareBasis));
    } else {
      let fare = flight.recommendations[0].returnFlights != null ? 
        flight.recommendations[0].returnFlights[0].categories[0].fare.departure : flight.recommendations[0].fare;
      let firstFareKey = Object.keys(fare)[0];
      let fareBasis = fare[firstFareKey].fareBasis;

      partner.push(this.extractPartner(fareBasis));
    }

    return partner;
  }
  
  extractPartner(fareBasis) {
    const parts = fareBasis.split("");
    if (fareBasis.includes("AWARD") && parts.length >= 3) {
      return parts[1] + parts[2];
    } else if (fareBasis.includes("P00") && parts.length >= 2) {
      const lastTwoElements = parts[parts.length - 2] + parts[parts.length - 1];
      if (lastTwoElements === "EK") {
        return lastTwoElements;
      }
    }
    return null;
  }

  getFareBasisFromFare(fare) {
    let fareWithCabinKey = Object.keys(_.pickBy(fare, function(value, key) {return !_.isEmpty(value)})).find(key => key !== '');
    let fareWithCabin = fare[fareWithCabinKey];
    let getDeparture = Object.keys(fareWithCabin)[0];
    let fareWithDeparture = fareWithCabin[getDeparture];
    let firstFare = Object.keys(fareWithDeparture)[0];
    return fareWithDeparture[firstFare].fareBasis;
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      messageInfo: null
    });
    window.location.reload();
  }

  renderModalError() {
    return (
      <div>
        <InfoModal
          id="modalerrorPointsPlusMoney"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalerrorPointsPlusMoney = c;
          }}
        />
      </div>
    );
  }

  renderCardOnlyPoints() {
    const colWidth = this.state.renderPointsPlusMoney ? 6 : 12;
    const classNotActive = this.state.onlyPointsIsChecked ? ' notActive' : '';
    return (
      <Col xs={12} md={colWidth} lg={colWidth}>
        <Col className={this.state.renderPointsPlusMoney ? 'FlightDetailsModal__containerOnlyPoints' : 'FlightDetailsModal__containerOnlyPointsCenter'}>
          <Col className={`FlightDetailsModal__radioAndLabelOnlyPoints${classNotActive}`}>
            <input className='FlightDetailsModal__radioOnlyPoints' type="radio"
              id="payWithPoints"
              name="payWithPoints"
              value="payWithPoints"
              onChange={() => {
                this.setState({ onlyPointsIsChecked: true });
                this.props.callbackSelectPointsPlusMoney(undefined);
              }
              }
              checked={this.state.onlyPointsIsChecked} />
            <span> {I18n.translate('modalSelect.label.payWithPoints')} </span>
          </Col>
          <Col className={this.state.onlyPointsIsChecked ? 'FlightDetailsModal__cardLabelOnlyPoints' : 'FlightDetailsModal__cardLabelOnlyPoints notActive'}>
            <Col className={`FlightDetailsModal__labelOnlyPoints${classNotActive}`}>
              {I18n.translate('modalSelect.value.points', {
                points: format.formatPoints(this.state.valuePoints)
              })}
            </Col>
          </Col>
        </Col>
      </Col>
    );
  }

  renderCardPointsPlusMoney() {
    if (this.state.renderPointsPlusMoney) {
      const classNotActive = this.state.onlyPointsIsChecked ? '' : ' notActive';
      return (
        <Col xs={12} md={6} lg={6}>
          <Col className='FlightDetailsModal__containerPointsAndMoney'>            
            <Col className={`FlightDetailsModal__radioandLabelPointsAndMoney${classNotActive}`}>
              <input type="radio" className='FlightDetailsModal__radioPointsAndMoney'
                id="payWithPointsAndMoney"
                name="payWithPointsAndMoney"
                value="payWithPointsAndMoney"
                onChange={() => {
                  this.setState({ onlyPointsIsChecked: false });
                  this.props.callbackSelectPointsPlusMoney(this.state.selectPointsPlusMoney);
                }
                }
                checked={!this.state.onlyPointsIsChecked} />
              <span>{I18n.translate('modalSelect.label.payWithPointsAndMoney')}</span>
            </Col>
            <Col className={this.state.onlyPointsIsChecked ? 'FlightDetailsModal__selectPointsAndMoney notActive' : 'FlightDetailsModal__selectPointsAndMoney'}>
              {this.renderItems()}              
              <div className={`FlightDetailsModal__labelSelectPointsAndMoney${classNotActive}`}>
                {I18n.translate('modalSelect.label.chooseAmoutPoints')}
              </div>
            </Col>
          </Col>
        </Col>
      );
    }
  }

  renderItems() {
    return (
      <Row>
        <Col xs={13} sm={12} md={12}>
          <SelectBoxPointsPlusMoney
            id="pointsPlusMoneyItems"
            label=""
            required={false}
            default={this.state.selectPointsPlusMoney ? this.state.selectPointsPlusMoney.id.toString() : null}
            values={this.state.optionAndValuesSelect.values}
            optionsLabel={this.state.optionAndValuesSelect.options}
            changeValue={this.changeValue}
            disabled={this.state.onlyPointsIsChecked}
          />
        </Col>
      </Row>
    );
  }

  renderPointsPlusMoney() {
    if (this.state.finalizeGetPointsPlusMoney)
      return (
        <Row className='FlightDetailsModal__containerPointsPlusMoney'>
          <div>
            {this.renderCardOnlyPoints()}
            {this.renderCardPointsPlusMoney()}
          </div>
        </Row>
      );
  }

  render() {
    if (this.props.onSelectRecomendation) {
      return (
        <div className='FlightDetailsModal__cardContainerPointsPlusMoney'>
          {this.renderPointsPlusMoney()}
          {this.renderModalError()}
        </div>
      );
    } else {
      return <div></div>
    }
  }
}

PointsPlusMoneyDetailModal.propTypes = propTypes;
PointsPlusMoneyDetailModal.defaultProps = defaultProps;

export default PointsPlusMoneyDetailModal;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightDetailsModal/PointsPlusMoneyDetailModal.jsx